import React__default, { forwardRef, createElement, useRef, useState, useEffect, Fragment as Fragment$1 } from 'react';
import NextLink from 'next/link';
import { version } from 'next/package.json';
import cx from 'classnames';
import { icons } from 'lucide-react';
import { Root, Trigger, Portal, Overlay, Content, Title, Description, Close } from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import { render } from 'datocms-structured-text-to-html-string';

var Blob = function Blob(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 1 : _ref$variant,
    className = _ref.className;
  if (variant === 1) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "219",
      height: "205",
      viewBox: "0 0 219 205",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M163.5 -90.9992C202.654 -91.1817 234.049 -61.0476 259.302 -31.1607C282.146 -4.12611 294.017 29.1656 294.917 64.5303C295.844 100.981 289.245 138.592 264.297 165.21C238.652 192.572 200.947 207.145 163.5 204.744C128.009 202.468 101.846 176.206 74.8647 153.062C44.3698 126.905 1.40848 104.656 0.0346213 64.5303C-1.35205 24.0302 39.2113 -2.32143 68.5876 -30.2717C96.8688 -57.1798 124.442 -90.8171 163.5 -90.9992Z",
      fill: "currentColor"
    }));
  }
  if (variant === 2) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "316",
      height: "223",
      viewBox: "0 0 316 223",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M307.381 222.479C234.602 220.528 191.951 147.253 137.21 99.2537C85.411 53.8356 10.3621 22.4256 1.33252 -45.8706C-7.82115 -115.105 46.2069 -174.082 94.3868 -224.638C138.314 -270.731 194.063 -296.537 255.644 -312.722C334.215 -333.373 421.67 -373.128 489.554 -328.501C559.98 -282.202 575.026 -185.772 576.92 -101.511C578.667 -23.806 549.095 49.2112 499.386 108.962C449.954 168.381 384.645 224.55 307.381 222.479Z",
      fill: "currentColor"
    }));
  }
  if (variant === 3) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "252",
      height: "213",
      viewBox: "0 0 252 213",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M352.332 100.002C322.434 147.793 289.784 204.846 233.891 211.5C178.796 218.059 138.263 166.354 95.9933 130.52C58.7156 98.9178 20.3269 67.5312 8.1644 20.1418C-5.12987 -31.6575 -1.15547 -88.3153 28.3566 -133.017C58.8957 -179.275 109.726 -209.277 164.566 -216.761C218.033 -224.057 270.594 -204.499 313.534 -171.934C355.306 -140.253 385.873 -95.2719 393.289 -43.2957C400.576 7.77912 379.73 56.2063 352.332 100.002Z",
      fill: "currentColor"
    }));
  }
  if (variant === 4) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "252",
      height: "213",
      viewBox: "0 0 252 213",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M352.332 100.002C322.434 147.793 289.784 204.846 233.891 211.5C178.796 218.059 138.263 166.354 95.9933 130.52C58.7156 98.9178 20.3269 67.5312 8.1644 20.1418C-5.12987 -31.6575 -1.15547 -88.3153 28.3566 -133.017C58.8957 -179.275 109.726 -209.277 164.566 -216.761C218.033 -224.057 270.594 -204.499 313.534 -171.934C355.306 -140.253 385.873 -95.2719 393.289 -43.2957C400.576 7.77912 379.73 56.2063 352.332 100.002Z",
      fill: "currentColor"
    }));
  }
  if (variant === 5) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "455",
      height: "279",
      viewBox: "0 0 455 279",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M222.576 93.0888C291.397 66.13 344.996 -16.1439 416.212 3.63871C489.97 24.1274 527.825 108.296 545.475 182.785C561.295 249.546 527.714 311.921 504.565 376.508C477.415 452.258 475.876 553.954 401.465 584.583C326.607 615.394 250.527 549.912 180.056 510.078C117.54 474.74 53.486 438.173 25.4751 372.049C-3.85972 302.8 -13.7323 216.48 29.6653 155.059C70.1811 97.7156 157.2 118.698 222.576 93.0888Z",
      fill: "currentColor"
    }));
  }
  if (variant === 6) {
    return /*#__PURE__*/React__default.createElement("svg", {
      width: "426",
      height: "201",
      viewBox: "0 0 426 201",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: className
    }, /*#__PURE__*/React__default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M50.325 -382.162C109.106 -448.144 208.638 -448.478 296.991 -446.868C375.296 -445.44 451.184 -424.491 510.856 -373.765C570.866 -322.752 605.195 -251.202 618.491 -173.568C633.452 -86.2054 640.853 8.8394 588.648 80.4686C533.394 156.282 439.577 206.076 345.937 200.396C259.472 195.151 205.408 114.257 143.687 53.4765C88.4777 -0.892437 28.9459 -51.9932 12.7086 -127.759C-5.96571 -214.895 -8.95303 -315.622 50.325 -382.162Z",
      fill: "currentColor"
    }));
  }
  return /*#__PURE__*/React__default.createElement(Fragment, null);
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var iconMap = {
  'arrow-down': 'ArrowDown',
  'arrow-left': 'ArrowLeft',
  'arrow-right': 'ArrowRight',
  'arrow-up-right': 'ArrowUpRight',
  'arrow-up': 'ArrowUp',
  'calendar-days': 'CalendarDays',
  'chevron-down': 'ChevronDown',
  'chevron-left': 'ChevronLeft',
  'chevron-right': 'ChevronRight',
  'chevron-up': 'ChevronUp',
  'circle-alert': 'CircleAlert',
  'circle-check': 'CircleCheck',
  'circle-dot-dashed': 'CircleDotDashed',
  'circle-help': 'CircleHelp',
  'circle-minus': 'CircleMinus',
  'circle-pause': 'CirclePause',
  'circle-play': 'CirclePlay',
  'circle-plus': 'CirclePlus',
  'circle-x': 'CircleX',
  'external-link': 'ExternalLink',
  'eye-off': 'EyeOff',
  'hand-helping': 'HandHelping',
  heart: 'Heart',
  'key-round': 'KeyRound',
  'log-out': 'LogOut',
  'map-pin': 'MapPin',
  'search-x': 'SearchX',
  'shopping-bag': 'ShoppingBag',
  'shopping-basket': 'ShoppingBasket',
  'shopping-cart': 'ShoppingCart',
  'sliders-horizontal': 'SlidersHorizontal',
  'square-split-horizontal': 'SquareSplitHorizontal',
  'triangle-alert': 'TriangleAlert',
  check: 'Check',
  clock: 'Clock',
  construction: 'Construction',
  contact: 'Contact',
  ellipsis: 'Ellipsis',
  eye: 'Eye',
  facebook: 'Facebook',
  home: 'House',
  info: 'Info',
  instagram: 'Instagram',
  loader: 'LoaderCircle',
  mail: 'Mail',
  menu: 'Menu',
  minus: 'Minus',
  'no-signal': 'WifiOff',
  "package": 'Package',
  pencil: 'Pencil',
  percent: 'Percent',
  placeholder: 'CircleDashed',
  plus: 'Plus',
  refresh: 'RefreshCw',
  repeat: 'Repeat',
  retour: 'Undo2',
  search: 'Search',
  shopping: 'ShoppingBag',
  skip: 'ChevronLast',
  sliders: 'SlidersHorizontal',
  sort: 'ArrowDownWideNarrow',
  stop: 'Ban',
  tag: 'Tag',
  trash: 'Trash2',
  truck: 'Truck',
  user: 'User',
  wrench: 'Wrench',
  'wifi-off': 'WifiOff',
  x: 'X'
};

var _excluded = ["name", "className"];
var Icon = function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var mappedName = iconMap[name];
  var LucideIcon = icons[mappedName];
  var classNames = cx('icon', className);
  if (!mappedName) {
    console.error('Icon not found:', name);
    return /*#__PURE__*/React__default.createElement(Fragment, null);
  }
  return /*#__PURE__*/React__default.createElement(LucideIcon, _extends({
    "aria-hidden": "true",
    className: classNames
  }, props));
};

var _excluded$1 = ["overlayScreen", "variant", "label", "className"];
var Spinner = function Spinner() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loader__spinner"
  }, /*#__PURE__*/React__default.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    className: "loader__spinner__icon"
  }, /*#__PURE__*/React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2.5",
    fill: "none",
    d: "M10,2.3c4.2,0,7.6,3.4,7.6,7.7c0,4.2-3.4,7.7-7.7,7.7S2.3,14.2,2.3,10S5.8,2.3,10,2.3"
  })));
};
var Logo = function Logo() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "loader__logo"
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 500 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    "clip-path": "url(#clip0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M186.148 137.513C167.617 137.513 154.201 122.813 154.201 104.416C154.201 83.8352 171.39 68.2106 193.862 72.8308C204.427 75.0149 213.148 83.0792 216.166 93.4116C222.874 116.512 207.781 137.513 186.148 137.513ZM198.809 49.4779C156.884 41.6656 122.422 72.5788 128.71 114.244C132.148 137.177 150.008 155.574 172.732 160.11C214.238 168.342 249.287 136.841 243.166 95.0076C239.98 73.9228 219.688 53.3421 198.809 49.4779Z",
    fill: "#004e4e"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M58.1922 137.513C39.6612 137.513 26.2452 122.813 26.2452 104.416C26.2452 83.8352 43.4345 68.2106 65.9064 72.8308C76.4716 75.0149 85.192 83.0792 88.2106 93.4116C94.9187 116.512 79.7417 137.513 58.1922 137.513ZM113.366 49.3939H92.487C90.9777 49.3939 89.8038 50.57 89.8038 52.082V57.5422C83.8504 53.5101 77.3939 50.654 70.8536 49.4779C28.9284 41.6656 -5.53414 72.5788 0.754645 114.244C4.19251 137.177 22.0527 155.574 44.7761 160.11C61.63 163.47 77.3939 160.278 89.8038 152.466V152.97C89.8038 170.275 77.6455 184.051 60.4561 185.311C59.0307 185.395 57.8568 186.571 57.8568 187.999L58.0245 206.48C58.0245 207.992 59.2822 209.252 60.7915 209.168C92.0677 207.908 115.965 184.471 115.965 152.97V52.082C116.049 50.654 114.875 49.3939 113.366 49.3939Z",
    fill: "#004e4e"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M335.821 83.9192L283.414 103.24C282.408 103.576 281.318 102.82 281.402 101.728C282.827 82.4912 299.514 68.4626 320.979 72.8308C326.933 74.0068 332.299 77.115 336.324 81.3991C337.079 82.2391 336.827 83.4992 335.821 83.9192ZM361.731 74.3428C353.262 61.9104 339.678 51.998 325.927 49.4779C284.253 41.6656 249.958 72.1588 255.744 113.488C255.744 113.74 255.828 113.992 255.828 114.244C257.169 122.981 260.523 131.045 265.47 137.933C273.52 149.19 285.762 157.338 299.849 160.11C329.113 165.906 355.107 151.962 365.756 128.609C366.175 127.601 365.42 126.509 364.414 126.509H337.749C337.33 126.509 336.911 126.677 336.659 127.013C330.958 133.565 322.74 137.597 313.265 137.597C305.299 137.597 298.256 134.825 292.806 130.289C291.967 129.533 292.135 128.105 293.225 127.685L312.343 120.629L369.613 99.5438C370.283 99.2918 370.619 98.7038 370.619 98.0318C370.535 97.0237 370.367 96.0157 370.283 95.0076C369.11 87.7834 366.091 80.7271 361.731 74.3428Z",
    fill: "#004e4e"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M408.351 95.5116C412.292 80.811 425.625 70.5626 440.802 70.5626C459.333 70.5626 474.426 85.6832 474.426 104.248C474.426 122.813 459.333 137.933 440.802 137.933C425.625 137.933 412.292 127.685 408.351 113.068L407.429 109.876C407.01 108.364 405.92 107.524 404.578 106.684C404.578 106.684 400.637 103.744 394.516 105.34C388.395 106.936 385.796 111.472 385.796 111.472C384.957 112.816 384.37 114.16 384.79 115.672L385.712 119.2C392.336 144.065 414.976 161.454 440.802 161.454C453.128 161.454 464.447 157.506 473.755 150.87L473.671 151.626V157.086C473.671 158.598 474.845 159.774 476.354 159.774H497.233C498.742 159.774 499.916 158.598 499.916 157.086V56.2821C499.916 24.7809 475.935 1.42796 444.743 0.0839124C443.233 -9.07869e-05 441.975 1.25996 441.975 2.77202L441.808 21.2527C441.808 22.6808 442.898 23.8568 444.407 23.9408C461.597 25.2009 473.755 38.9774 473.755 56.2821V56.7861V57.7941C464.447 51.1579 453.128 47.2937 440.802 47.2937C415.06 47.2937 392.42 64.6824 385.712 89.5473L384.79 94.0835C384.37 95.5956 384.957 96.9396 385.796 98.2837C385.796 98.2837 388.395 102.904 394.516 104.416C400.637 105.928 404.578 103.072 404.578 103.072C405.92 102.232 407.094 101.392 407.429 99.8797L408.351 95.5116Z",
    fill: "#004e4e"
  }))));
};
var Loader = function Loader(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'spinner' : _ref$variant,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Laden...' : _ref$label,
    className = _ref.className,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var classNames = cx(className, 'loader');
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames
  }, restProps), variant === 'spinner' && /*#__PURE__*/React__default.createElement(Spinner, null), variant === 'logo' && /*#__PURE__*/React__default.createElement(Logo, null), /*#__PURE__*/React__default.createElement("span", {
    className: "loader__label u-visually-hidden",
    "aria-hidden": "true"
  }, label));
};

var _excluded$2 = ["variant", "size", "onClick", "className", "modLoading", "modOutline", "disabled", "buttonPrefix", "buttonAffix", "iconAfter", "iconBefore", "modEllipsis", "modBlock", "modLowercase", "href", "children", "linkComponent"];
var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    onClick = _ref.onClick,
    className = _ref.className,
    modLoading = _ref.modLoading,
    modOutline = _ref.modOutline,
    disabled = _ref.disabled,
    buttonPrefix = _ref.buttonPrefix,
    buttonAffix = _ref.buttonAffix,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    _ref$modEllipsis = _ref.modEllipsis,
    modEllipsis = _ref$modEllipsis === void 0 ? true : _ref$modEllipsis,
    modBlock = _ref.modBlock,
    _ref$modLowercase = _ref.modLowercase,
    modLowercase = _ref$modLowercase === void 0 ? true : _ref$modLowercase,
    href = _ref.href,
    children = _ref.children,
    linkComponent = _ref.linkComponent,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var classNames = cx(className, 'button', "button--" + size, "button--" + variant, {
    'button--loading': modLoading,
    'button--outline': modOutline,
    'button--ellipsis': modEllipsis,
    'button--block': modBlock,
    'button--lowercase': modLowercase
  });
  var Link = linkComponent != null ? linkComponent : NextLink;
  if (href) {
    if (parseInt(version) < 13) {
      return /*#__PURE__*/React__default.createElement(Link, {
        href: href
      }, /*#__PURE__*/React__default.createElement("a", {
        className: classNames,
        target: props === null || props === void 0 ? void 0 : props.target
      }, buttonPrefix, iconBefore && /*#__PURE__*/React__default.createElement(Icon, {
        name: iconBefore,
        className: "button__icon button__icon--before"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "button__label"
      }, children), iconAfter && /*#__PURE__*/React__default.createElement(Icon, {
        name: iconAfter,
        className: "button__icon button__icon--before"
      }), buttonAffix, modLoading && /*#__PURE__*/React__default.createElement(Loader, {
        variant: "spinner",
        className: "button__loader"
      })));
    }
    return /*#__PURE__*/React__default.createElement(Link, {
      href: href,
      className: classNames,
      target: props === null || props === void 0 ? void 0 : props.target
    }, buttonPrefix, iconBefore && /*#__PURE__*/React__default.createElement(Icon, {
      name: iconBefore,
      className: "button__icon button__icon--before"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "button__label"
    }, children), iconAfter && /*#__PURE__*/React__default.createElement(Icon, {
      name: iconAfter,
      className: "button__icon button__icon--before"
    }), buttonAffix, modLoading && /*#__PURE__*/React__default.createElement(Loader, {
      variant: "spinner",
      className: "button__loader"
    }));
  }
  return /*#__PURE__*/React__default.createElement("button", _extends({
    onClick: onClick,
    className: classNames,
    disabled: disabled
  }, props), buttonPrefix, iconBefore && /*#__PURE__*/React__default.createElement(Icon, {
    name: iconBefore,
    className: "button__icon button__icon--before"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "button__label"
  }, children), iconAfter && /*#__PURE__*/React__default.createElement(Icon, {
    name: iconAfter,
    className: "button__icon button__icon--before"
  }), buttonAffix, modLoading && /*#__PURE__*/React__default.createElement(Loader, {
    variant: "spinner",
    className: "button__loader"
  }));
};

var _excluded$3 = ["className"],
  _excluded2 = ["className", "children", "type", "size", "background"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"];
var Dialog = Root;
var DialogTrigger = Trigger;
var DialogPortal = Portal;
var DialogOverlay = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return /*#__PURE__*/createElement(Overlay, _extends({
    ref: ref,
    className: cx('dialog__overlay', className)
  }, props));
});
DialogOverlay.displayName = Overlay.displayName;
var dialogContentVariants = cva(['dialog'], {
  variants: {
    type: {
      dialog: 'dialog--dialog',
      dialogWide: 'dialog--dialog dialog--dialog-wide',
      slideOver: 'dialog--slide-over',
      drawer: 'dialog--drawer'
    },
    size: {
      md: 'dialog--md',
      lg: 'dialog--lg',
      xl: 'dialog--xl'
    },
    background: {
      primary: 'u-bg-primary',
      white: 'u-bg-white',
      'off-white': 'u-bg-off-white'
    }
  },
  defaultVariants: {
    type: 'dialog',
    size: 'md',
    background: 'white'
  }
});
var DialogContent = forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    children = _ref2.children,
    type = _ref2.type,
    size = _ref2.size,
    background = _ref2.background,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/createElement(DialogPortal, null, /*#__PURE__*/createElement("div", {
    className: "dialog-container"
  }, /*#__PURE__*/createElement(DialogOverlay, {
    className: cx('dialog__backdrop')
  }), /*#__PURE__*/createElement(Content, _extends({}, props, {
    ref: ref,
    className: cx(dialogContentVariants({
      background: background,
      type: type,
      size: size
    }), className)
  }), children)));
});
DialogContent.displayName = Content.displayName;
var DialogHeader = function DialogHeader(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  return /*#__PURE__*/createElement("div", _extends({
    className: cx('dialog__header', className)
  }, props));
};
DialogHeader.displayName = 'DialogHeader';
var DialogFooter = function DialogFooter(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /*#__PURE__*/createElement("div", _extends({
    className: cx('dialog__footer', className)
  }, props));
};
DialogFooter.displayName = 'DialogFooter';
var DialogInner = function DialogInner(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  return /*#__PURE__*/createElement("div", _extends({
    className: cx('dialog__inner', className)
  }, props));
};
DialogHeader.displayName = 'DialogHeader';
var DialogTitle = forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutPropertiesLoose(_ref6, _excluded6);
  return /*#__PURE__*/createElement(Title, _extends({
    ref: ref,
    className: cx('dialog__title', className)
  }, props));
});
DialogTitle.displayName = Title.displayName;
var DialogDescription = forwardRef(function (_ref7, ref) {
  var className = _ref7.className,
    props = _objectWithoutPropertiesLoose(_ref7, _excluded7);
  return /*#__PURE__*/createElement(Description, _extends({
    ref: ref,
    className: cx('dialog__description', className)
  }, props));
});
DialogDescription.displayName = Description.displayName;

var _excluded$4 = ["className", "children", "variant", "closeLabel"];
var dialogCloseVariants = cva(['dialog__close close-button'], {
  variants: {
    variant: {
      transparent: 'close-button--transparent',
      black: 'close-button--black',
      box: 'close-button--box',
      circle: 'close-button--circle'
    },
    position: {
      relative: 'close-button--relative',
      fixed: 'close-button--fixed',
      absolute: 'close-button--absolute'
    }
  },
  defaultVariants: {
    variant: 'transparent',
    position: 'relative'
  }
});
var DialogClose = React__default.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
    _ref$closeLabel = _ref.closeLabel,
    closeLabel = _ref$closeLabel === void 0 ? 'Sluiten' : _ref$closeLabel,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return /*#__PURE__*/React__default.createElement(Close, _extends({
    className: cx(dialogCloseVariants({
      variant: variant
    })),
    ref: ref
  }, props), /*#__PURE__*/React__default.createElement(Icon, {
    name: "x",
    className: "close-button__icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "close-button__text u-sr-only"
  }, closeLabel));
});
DialogClose.displayName = Close.displayName;

var _excluded$5 = ["className", "variant", "tagName", "children", "modLowercase"];
var Heading = function Heading(_ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
    tagName = _ref.tagName,
    children = _ref.children,
    _ref$modLowercase = _ref.modLowercase,
    modLowercase = _ref$modLowercase === void 0 ? true : _ref$modLowercase,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var classNames = cx(className, tagName && "heading--" + variant, modLowercase && 'u-lowercase');
  var Element = tagName != null ? tagName : variant;
  return /*#__PURE__*/React__default.createElement(Element, _extends({
    className: classNames
  }, props), children);
};

var _excluded$6 = ["size", "variant", "onClick", "className", "disabled", "iconName", "label", "modSquare", "modGhost", "href", "children", "linkComponent"];
var IconButton = function IconButton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    onClick = _ref.onClick,
    className = _ref.className,
    disabled = _ref.disabled,
    iconName = _ref.iconName,
    label = _ref.label,
    modSquare = _ref.modSquare,
    modGhost = _ref.modGhost,
    href = _ref.href,
    children = _ref.children,
    linkComponent = _ref.linkComponent,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var classNames = cx(className, 'icon-button', "icon-button--size-" + size, "icon-button--" + variant, modSquare && "icon-button--square", modGhost && "icon-button--ghost");
  if (!iconName && !children) console.error('IconButton: Missing icon name or children');
  var Link = linkComponent != null ? linkComponent : NextLink;
  var IconElement = iconName ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    className: "icon-button__icon"
  }) : /*#__PURE__*/React__default.createElement("span", {
    className: "icon-button__icon"
  }, children);
  if (href) {
    if (parseInt(version) < 13) {
      return /*#__PURE__*/React__default.createElement(Link, {
        href: href
      }, /*#__PURE__*/React__default.createElement("a", {
        className: classNames,
        "aria-label": label
      }, IconElement));
    }
    return /*#__PURE__*/React__default.createElement(Link, {
      href: href,
      className: classNames,
      "aria-label": label
    }, IconElement);
  }
  return /*#__PURE__*/React__default.createElement("button", _extends({
    onClick: onClick,
    className: classNames,
    disabled: disabled,
    "aria-label": label
  }, props), IconElement);
};

var _excluded$7 = ["label", "iconBefore", "iconAfter", "href", "query", "onClick", "variant", "size", "modTextUnderline", "modLowercase", "className", "disabled", "linkComponent"];
var Link = function Link(_ref) {
  var _ref2;
  var label = _ref.label,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    href = _ref.href,
    query = _ref.query,
    onClick = _ref.onClick,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'purple' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$modTextUnderline = _ref.modTextUnderline,
    modTextUnderline = _ref$modTextUnderline === void 0 ? true : _ref$modTextUnderline,
    _ref$modLowercase = _ref.modLowercase,
    modLowercase = _ref$modLowercase === void 0 ? true : _ref$modLowercase,
    className = _ref.className,
    disabled = _ref.disabled,
    linkComponent = _ref.linkComponent,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var NextLink;
  try {
    NextLink = require('next/link')["default"];
  } catch (error) {
    NextLink = null;
  }
  var classNames = cx('link', !disabled && "link--" + variant, "link--" + size, {
    'link--underline': modTextUnderline && !disabled,
    'u-lowercase': modLowercase
  }, className);
  var iconSize = size === 'sm' ? 12 : 16;
  var Component = (_ref2 = linkComponent != null ? linkComponent : NextLink) != null ? _ref2 : 'a';
  if (href) {
    var hrefObject = typeof href === 'string' ? _extends({
      pathname: href
    }, query && {
      query: {
        query: query
      }
    }) : href;
    if (parseInt(version) < 13) {
      return /*#__PURE__*/React__default.createElement(Component, _extends({
        href: hrefObject
      }, props), /*#__PURE__*/React__default.createElement("a", {
        className: classNames
      }, iconBefore && typeof iconBefore === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
        name: iconBefore,
        size: iconSize,
        className: "link__icon"
      }) : iconBefore, label, iconAfter && typeof iconAfter === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
        name: iconAfter,
        size: iconSize,
        className: "link__icon"
      }) : iconAfter));
    }
    return /*#__PURE__*/React__default.createElement(Component, _extends({
      href: hrefObject,
      className: classNames
    }, props), iconBefore && typeof iconBefore === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
      name: iconBefore,
      size: iconSize,
      className: "link__icon"
    }) : iconBefore, label, iconAfter && typeof iconAfter === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
      name: iconAfter,
      size: iconSize,
      className: "link__icon"
    }) : iconAfter);
  }
  return /*#__PURE__*/React__default.createElement("button", {
    onClick: onClick,
    className: classNames,
    disabled: disabled,
    type: "button"
  }, iconBefore && typeof iconBefore === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconBefore,
    size: iconSize,
    className: "link__icon"
  }) : iconBefore, label, iconAfter && typeof iconAfter === 'string' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconAfter,
    size: iconSize,
    className: "link__icon"
  }) : iconAfter);
};

var _excluded$8 = ["variant", "href", "className", "linkComponent", "modUld"];
var Logo$1 = function Logo(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    href = _ref.href,
    className = _ref.className,
    linkComponent = _ref.linkComponent,
    _ref$modUld = _ref.modUld,
    modUld = _ref$modUld === void 0 ? false : _ref$modUld,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var classNames = cx(className, 'logo', "logo--" + variant, href && 'logo--clickable');
  var Link = linkComponent != null ? linkComponent : NextLink;
  var LogoComponent = modUld ? LogoUld : LogoGoed;
  if (href) {
    if (parseInt(version) < 13) {
      return /*#__PURE__*/React__default.createElement(Link, _extends({}, props, {
        href: href
      }), /*#__PURE__*/React__default.createElement("a", {
        className: classNames,
        "aria-label": "Goed"
      }, /*#__PURE__*/React__default.createElement(LogoComponent, null)));
    }
    return /*#__PURE__*/React__default.createElement(Link, _extends({}, props, {
      href: href,
      className: classNames,
      "aria-label": "Goed"
    }), /*#__PURE__*/React__default.createElement(LogoComponent, null));
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames,
    "aria-label": "Goed"
  }, props), /*#__PURE__*/React__default.createElement(LogoComponent, null));
};
var LogoGoed = function LogoGoed() {
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 95 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M35.2701 26.3185C31.759 26.3185 29.217 23.505 29.217 19.9841C29.217 16.0451 32.4739 13.0548 36.7318 13.939C38.7336 14.357 40.3859 15.9005 40.9578 17.8779C42.2288 22.2992 39.3691 26.3185 35.2701 26.3185ZM37.6691 9.46959C29.7254 7.97441 23.1957 13.8908 24.3872 21.8651C25.0386 26.2541 28.4226 29.775 32.7281 30.6432C40.5924 32.2188 47.2334 26.1898 46.0736 18.1834C45.4699 14.148 41.6251 10.2091 37.6691 9.46959Z",
    fill: "var(--logo-fill)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.0259 26.3185C7.51476 26.3185 4.97277 23.505 4.97277 19.9841C4.97277 16.0452 8.2297 13.0548 12.4875 13.939C14.4894 14.357 16.1416 15.9005 16.7136 17.8779C17.9846 22.2992 15.109 26.3185 11.0259 26.3185ZM21.4798 9.45351H17.5239C17.2379 9.45351 17.0155 9.67859 17.0155 9.96798V11.013C15.8874 10.2413 14.6641 9.69467 13.4249 9.46959C5.48117 7.97441 -1.04857 13.8908 0.142985 21.8651C0.794371 26.2542 4.1784 29.7751 8.4839 30.6432C11.6773 31.2863 14.6641 30.6754 17.0155 29.1802V29.2767C17.0155 32.5886 14.7118 35.2252 11.4549 35.4664C11.1848 35.4824 10.9623 35.7075 10.9623 35.9808L10.9941 39.5178C10.9941 39.8072 11.2324 40.0484 11.5184 40.0323C17.4444 39.7911 21.9723 35.3056 21.9723 29.2767V9.96798C21.9882 9.69467 21.7658 9.45351 21.4798 9.45351Z",
    fill: "var(--logo-fill)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M63.6292 16.0613L53.6996 19.759C53.5089 19.8233 53.3024 19.6786 53.3183 19.4696C53.5884 15.7879 56.75 13.1031 60.8172 13.9391C61.9452 14.1642 62.962 14.759 63.7246 15.5789C63.8676 15.7397 63.8199 15.9809 63.6292 16.0613ZM68.5385 14.2285C66.9338 11.849 64.3601 9.95194 61.7545 9.46962C53.8585 7.97445 47.3605 13.8105 48.4567 21.7204C48.4567 21.7687 48.4726 21.8169 48.4726 21.8651C48.7268 23.5371 49.3623 25.0806 50.2997 26.3989C51.8249 28.5532 54.1444 30.1127 56.8135 30.6433C62.3582 31.7526 67.2834 29.0838 69.3011 24.6143C69.3805 24.4214 69.2375 24.2124 69.0469 24.2124H63.9946C63.9152 24.2124 63.8358 24.2445 63.7881 24.3088C62.7078 25.5629 61.1508 26.3346 59.3555 26.3346C57.8462 26.3346 56.5117 25.804 55.479 24.9359C55.3201 24.7912 55.3519 24.5178 55.5584 24.4375L59.1808 23.087L70.0319 19.0516C70.159 19.0034 70.2225 18.8908 70.2225 18.7622C70.2066 18.5693 70.1749 18.3764 70.159 18.1834C69.9366 16.8008 69.3646 15.4503 68.5385 14.2285Z",
    fill: "var(--logo-fill)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M77.3719 18.2799C78.1186 15.4664 80.6447 13.505 83.5203 13.505C87.0314 13.505 89.8912 16.3989 89.8912 19.9519C89.8912 23.505 87.0314 26.3989 83.5203 26.3989C80.6447 26.3989 78.1186 24.4375 77.3719 21.64L77.1971 21.0291C77.1177 20.7397 76.9111 20.5789 76.6569 20.4182C76.6569 20.4182 75.9102 19.8555 74.7504 20.1609C73.5907 20.4664 73.0981 21.3346 73.0981 21.3346C72.9393 21.5918 72.8281 21.849 72.9075 22.1384L73.0823 22.8137C74.3374 27.5725 78.627 30.9005 83.5203 30.9005C85.8558 30.9005 88.0006 30.1449 89.7641 28.8748L89.7482 29.0194V30.0645C89.7482 30.3539 89.9706 30.5789 90.2566 30.5789H94.2126C94.4985 30.5789 94.721 30.3539 94.721 30.0645V10.7719C94.721 4.74292 90.1772 0.273467 84.267 0.0162325C83.981 0.000155361 83.7427 0.241313 83.7427 0.530702L83.711 4.06768C83.711 4.34099 83.9175 4.56607 84.2035 4.58215C87.4604 4.82331 89.7641 7.45996 89.7641 10.7719V10.8683V11.0613C88.0006 9.79115 85.8558 9.0516 83.5203 9.0516C78.6429 9.0516 74.3533 12.3796 73.0823 17.1384L72.9075 18.0066C72.8281 18.296 72.9393 18.5532 73.0981 18.8104C73.0981 18.8104 73.5907 19.6947 74.7504 19.9841C75.9102 20.2735 76.6569 19.7268 76.6569 19.7268C76.9111 19.5661 77.1336 19.4053 77.1971 19.1159L77.3719 18.2799Z",
    fill: "var(--logo-fill)"
  })));
};
var LogoUld = function LogoUld() {
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8894 12.879C79.0648 12.879 76.5904 14.7496 75.86 17.4252V17.4327L75.6886 18.2152C75.6215 18.491 75.4128 18.6475 75.1594 18.7966C75.1594 18.7966 74.7387 19.1014 74.0407 19.1245C74.7387 19.1476 75.1594 19.4524 75.1594 19.4524C75.4128 19.594 75.6141 19.758 75.6886 20.0338L75.86 20.6151C76.5904 23.2907 79.0722 25.1614 81.8894 25.1614C85.3252 25.1614 88.1275 22.4038 88.1275 19.0202C88.1275 15.6365 85.3327 12.879 81.8894 12.879ZM73.8725 19.1245C73.6951 19.1303 73.5023 19.155 73.2962 19.2065C72.1634 19.4897 71.6789 20.3244 71.6789 20.3244C71.5299 20.5704 71.4181 20.8089 71.4926 21.0846L71.664 21.7256C72.9012 26.2719 77.1047 29.4393 81.8894 29.4393C84.17 29.4393 86.2867 28.7239 88.0157 27.509V27.6432L88.0083 28.6344C88.0083 28.9027 88.2319 29.1189 88.5076 29.1189H92.3906C92.6664 29.1189 92.8899 28.9027 92.8899 28.6344V10.2481C92.8899 4.49442 88.4405 0.231344 82.6347 0.000303173C82.359 -0.00714975 82.1279 0.216438 82.1205 0.484743L82.0907 3.86092C82.0907 4.12177 82.2993 4.33045 82.5676 4.35281C85.765 4.58385 88.0157 7.09549 88.0157 10.2555V10.5313C86.2867 9.32391 84.1775 8.60843 81.8969 8.60843C77.1121 8.60843 72.9012 11.7834 71.664 16.3297L71.4926 17.1644C71.4181 17.4401 71.5224 17.6786 71.6789 17.9246C71.6789 17.9246 72.1634 18.7593 73.2962 19.0425C73.5023 19.094 73.6951 19.1187 73.8725 19.1245ZM67.1922 13.5646C65.6122 11.2914 63.1006 9.48783 60.5442 9.0183C52.8081 7.59479 46.4284 13.1621 47.5016 20.697C47.5016 20.7417 47.5091 20.7865 47.5165 20.8312C47.7625 22.4261 48.396 23.8943 49.3127 25.1539C50.8107 27.2034 53.0764 28.694 55.6924 29.2008C61.1256 30.2591 65.9625 27.7177 67.945 23.4546C68.027 23.2757 67.8928 23.0745 67.6916 23.0745H62.7354C62.6609 23.0745 62.5863 23.1118 62.5342 23.1639C61.4758 24.3564 59.9555 25.1017 58.1891 25.1017C56.706 25.1017 55.4017 24.6024 54.3956 23.7602C54.2316 23.626 54.2763 23.3652 54.4776 23.2906L58.0251 22.0013L68.6605 18.1481C68.7797 18.1034 68.8542 17.9916 68.8393 17.8649C68.8244 17.6861 68.8021 17.4997 68.7723 17.3209C68.5785 16.0166 68.0046 14.7347 67.1922 13.5646ZM62.3851 15.3086L52.6516 18.8338C52.4653 18.9009 52.264 18.7593 52.2789 18.5655C52.5472 15.0552 55.6402 12.4914 59.6275 13.2888C60.7306 13.5124 61.7218 14.0714 62.482 14.8614C62.6236 15.003 62.5714 15.2415 62.3777 15.3086H62.3851ZM17.1831 9.01833H21.0661L21.0587 9.02579C21.3344 9.02579 21.558 9.24192 21.558 9.51022V27.8966C21.558 33.6428 17.1086 37.9059 11.3028 38.1443C11.0196 38.1593 10.7885 37.9357 10.7885 37.6599L10.7587 34.2837C10.7587 34.0154 10.9674 33.8142 11.2357 33.7918C14.433 33.5608 16.6838 31.0417 16.6838 27.8891V27.7997C14.3808 29.2232 11.4444 29.812 8.31417 29.2008C4.09581 28.381 0.779263 25.0198 0.138312 20.8312C-1.0318 13.2292 5.38517 7.58737 13.166 9.01833C14.3808 9.24192 15.5808 9.76362 16.6838 10.494V9.50277C16.6838 9.23447 16.9074 9.01833 17.1831 9.01833ZM4.87837 19.0649C4.87837 22.4112 7.36019 25.1017 10.8034 25.1017V25.1092C14.8206 25.1092 17.6378 21.2784 16.3931 17.06C15.8342 15.1595 14.2169 13.6913 12.2493 13.2963C8.07568 12.4541 4.87837 15.3086 4.87837 19.0649ZM34.5336 25.0943C31.1127 25.0719 28.6457 22.3963 28.6457 19.0574C28.6457 15.7185 31.1052 13.1621 34.5336 13.1398C37.9619 13.1621 40.4214 15.7558 40.4214 19.0574C40.4214 22.359 37.9619 25.0719 34.5336 25.0943ZM34.541 8.80219H34.5336H34.5112C27.8781 8.81709 22.8623 14.0416 23.9057 20.8387C24.5466 25.0272 27.8632 28.3885 32.0815 29.2083C32.9088 29.3648 33.7137 29.4468 34.5037 29.4468H34.5261H34.5485C35.3385 29.4468 36.1508 29.3648 36.9707 29.2083C41.189 28.3885 44.5056 25.0272 45.1465 20.8387C46.1899 14.0416 41.1816 8.81709 34.541 8.80219ZM44.8111 33.9558C44.8111 33.5906 45.072 33.3297 45.4372 33.3297C45.8024 33.3297 46.0632 33.5906 46.0632 33.9558C46.0632 34.321 45.8024 34.5818 45.4372 34.5818C45.072 34.5818 44.8111 34.321 44.8111 33.9558ZM45.0422 39.8883V35.2824H45.8322V39.8883H45.0422ZM43.6932 39.8883H42.933V39.2249C42.5753 39.7392 42.1504 40 41.4573 40C40.168 40 39.7357 39.1504 39.7357 38.0101V35.2823H40.5481V38.0101C40.5481 38.7405 40.7567 39.2622 41.5989 39.2622C42.6498 39.2622 42.9032 38.3977 42.9032 37.4288V35.2823H43.6932V39.8883ZM47.5687 38.5989C47.5687 39.5752 48.0084 39.933 48.8432 39.933C49.1338 39.933 49.3947 39.8883 49.6332 39.8212V39.1206C49.3872 39.1653 49.186 39.1951 48.8879 39.1951C48.5003 39.1951 48.3587 38.9939 48.3587 38.6436V35.9755H49.6183V35.2824H48.3587V34.0452H47.5687V35.2824H46.6595V35.9755H47.5687V38.5989ZM51.325 39.8883H50.5126V33.4415H51.325V39.8883ZM56.7284 37.5853C56.7284 36.2227 55.9621 35.1725 54.5187 35.1706C53.1345 35.1725 52.2491 36.2674 52.2491 37.6226C52.2491 39.0759 53.2031 40.0001 54.5968 40.0001C55.4539 40.0001 56.065 39.5902 56.4377 39.1728L56.0203 38.5542C55.6998 38.9343 55.2303 39.2622 54.5596 39.2622C53.777 39.2622 53.0913 38.7704 53.0466 37.8238H56.7284V37.5853ZM53.0839 37.1903C53.1957 36.4227 53.6652 35.9084 54.5297 35.9084C55.357 35.9084 55.7893 36.4227 55.8638 37.1903H53.0839ZM59.5643 35.1706C61.0077 35.1725 61.774 36.2227 61.774 37.5853V37.8238H58.0923C58.137 38.7704 58.8226 39.2622 59.6052 39.2622C60.276 39.2622 60.7455 38.9343 61.066 38.5542L61.4833 39.1728C61.1107 39.5902 60.4996 40.0001 59.6425 40.0001C58.2488 40.0001 57.2948 39.0759 57.2948 37.6226C57.2948 36.2674 58.1802 35.1725 59.5643 35.1706ZM59.5679 35.9084C58.7034 35.9084 58.2339 36.4227 58.1221 37.1903H60.902C60.8275 36.4227 60.3952 35.9084 59.5679 35.9084ZM63.4583 35.2824H62.6907V39.8883H63.4807V37.7419C63.4807 36.527 63.913 35.9084 64.77 35.9084C65.5004 35.9084 65.9029 36.3556 65.9029 37.1456V39.8883H66.7153V37.1158C66.7153 35.8861 66.0817 35.1706 64.9936 35.1706C64.3452 35.1706 63.8012 35.4314 63.4583 35.9904V35.2824ZM72.2677 39.8883H71.4777V39.225C71.0976 39.7318 70.5386 40.0001 69.8604 40.0001C68.5561 40.0001 67.6394 39.0089 67.6394 37.5854C67.6394 36.1618 68.5487 35.1706 69.8604 35.1706C70.5162 35.1706 71.0454 35.4315 71.4777 35.9532V33.4341H72.2677V39.8809V39.8883ZM68.4592 37.5854C68.4592 38.599 69.0704 39.2623 69.9945 39.2623C70.9187 39.2623 71.5298 38.6064 71.5298 37.5854C71.5298 36.5643 70.9187 35.9085 69.9945 35.9085C69.0704 35.9085 68.4592 36.5718 68.4592 37.5854ZM74.0042 33.3297C73.639 33.3297 73.3782 33.5906 73.3782 33.9558C73.3782 34.321 73.639 34.5818 74.0042 34.5818C74.3694 34.5818 74.6303 34.321 74.6303 33.9558C74.6303 33.5906 74.3694 33.3297 74.0042 33.3297ZM73.6092 35.2824V39.8883H74.3992V35.2824H73.6092ZM77.5148 35.1706C78.9557 35.1743 79.7206 36.2239 79.7206 37.5853V37.8238H76.0388C76.0836 38.7704 76.7692 39.2622 77.5518 39.2622C78.2226 39.2622 78.6921 38.9343 79.02 38.5542L79.4374 39.1728C79.0722 39.5902 78.4536 40.0001 77.5965 40.0001C76.2028 40.0001 75.2488 39.0759 75.2488 37.6226C75.2488 36.2685 76.1327 35.1744 77.5148 35.1706ZM77.5148 35.1706L77.5071 35.1706H77.522L77.5148 35.1706ZM77.5145 35.9084C76.65 35.9084 76.1805 36.4227 76.0687 37.1903H78.8486C78.7741 36.4227 78.3418 35.9084 77.5145 35.9084ZM81.405 35.2824H80.6373V39.8883H81.4273V37.7419C81.4273 36.527 81.8596 35.9084 82.7167 35.9084C83.4471 35.9084 83.8495 36.3556 83.8495 37.1456V39.8883H84.6619V37.1158C84.6619 35.8861 84.0284 35.1706 82.9403 35.1706C82.2919 35.1706 81.7478 35.4314 81.405 35.9904V35.2824ZM87.5238 35.1706C88.3585 35.1706 88.9697 35.506 89.3349 36.1618L88.679 36.5792C88.448 36.1395 88.0455 35.9084 87.4791 35.9084C86.9127 35.9084 86.5773 36.1246 86.5773 36.5047C86.5773 36.8848 86.9648 37.004 87.6729 37.1754C88.6418 37.4139 89.3274 37.6152 89.3274 38.5542C89.3274 39.4933 88.679 39.9926 87.5611 39.9926C86.5997 39.9926 85.8544 39.5976 85.5264 38.912L86.1823 38.4946C86.4208 38.979 86.9127 39.2474 87.5909 39.2474C88.2095 39.2474 88.5374 39.0238 88.5374 38.5989C88.5374 38.1741 88.1871 38.0772 87.5164 37.9207C86.6593 37.7195 85.7873 37.481 85.7873 36.5196C85.7873 35.6923 86.4506 35.1557 87.5164 35.1557L87.5238 35.1706ZM90.6168 38.5989C90.6168 39.5752 91.0565 39.933 91.8912 39.933C92.1819 39.933 92.4427 39.8883 92.6812 39.8212V39.1206C92.4353 39.1653 92.2341 39.1951 91.936 39.1951C91.5484 39.1951 91.4068 38.9939 91.4068 38.6436V35.9755H92.6663V35.2824H91.4068V34.0452H90.6168V35.2824H89.7075V35.9755H90.6168V38.5989Z",
    fill: "var(--logo-fill)"
  }));
};

var _excluded$9 = ["classNames", "tagName", "data", "numberOfLines", "children", "labels"];
var TextWithNumberOfLines = function TextWithNumberOfLines(_ref) {
  var classNames = _ref.classNames,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'p' : _ref$tagName,
    data = _ref.data,
    numberOfLines = _ref.numberOfLines,
    children = _ref.children,
    labels = _ref.labels,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var ref = useRef(null);
  var Element = tagName;
  var _useState = useState(false),
    showAll = _useState[0],
    setShowAll = _useState[1];
  var _useState2 = useState(false),
    shouldClamp = _useState2[0],
    setShouldClamp = _useState2[1];
  useEffect(function () {
    if (!ref.current) {
      return;
    }
    setShouldClamp(ref.current.clientHeight !== ref.current.scrollHeight);
  }, [ref, numberOfLines, setShouldClamp]);
  return /*#__PURE__*/React__default.createElement(Element, _extends({
    className: classNames
  }, props), /*#__PURE__*/React__default.createElement("span", {
    ref: ref,
    id: "text-content",
    className: cx('text__clamped-content', {
      'is-clamped': !showAll
    }),
    style: {
      WebkitLineClamp: !showAll && numberOfLines
    }
  }, data ? render(data) : children), shouldClamp && /*#__PURE__*/React__default.createElement(Link, {
    className: "text__read-more-button",
    label: labels ? showAll ? labels === null || labels === void 0 ? void 0 : labels.showLess : labels === null || labels === void 0 ? void 0 : labels.readMore : '',
    onClick: function onClick() {
      return setShowAll(!showAll);
    },
    "aria-expanded": showAll,
    "aria-controls": "text-content"
  }));
};

var _excluded$a = ["className", "variant", "variants", "tagName", "children", "data", "numberOfLines", "modDangerouslySetInnerHTML"];
var Text = function Text(_ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$variants = _ref.variants,
    variants = _ref$variants === void 0 ? [] : _ref$variants,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'p' : _ref$tagName,
    children = _ref.children,
    data = _ref.data,
    numberOfLines = _ref.numberOfLines,
    modDangerouslySetInnerHTML = _ref.modDangerouslySetInnerHTML,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var classNames = cx("text--" + variant, variants.map(function (v) {
    return "text--" + v;
  }).join(' '), data && 'text--structured', numberOfLines && 'text--clamped', className);
  var Element = tagName;
  if (modDangerouslySetInnerHTML && typeof children === 'string') {
    if (numberOfLines) {
      return /*#__PURE__*/React__default.createElement(TextWithNumberOfLines, {
        numberOfLines: numberOfLines,
        classNames: classNames,
        tagName: "div"
      }, /*#__PURE__*/React__default.createElement("div", _extends({
        className: classNames
      }, props), /*#__PURE__*/React__default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: children
        },
        suppressHydrationWarning: true
      })));
    }
    return /*#__PURE__*/React__default.createElement("div", _extends({
      suppressHydrationWarning: true,
      className: classNames,
      dangerouslySetInnerHTML: {
        __html: children
      }
    }, props));
  }
  if (numberOfLines) {
    if (data) {
      return /*#__PURE__*/React__default.createElement(TextWithNumberOfLines, {
        numberOfLines: numberOfLines,
        classNames: classNames,
        tagName: tagName,
        data: data
      });
    }
    return /*#__PURE__*/React__default.createElement(TextWithNumberOfLines, {
      numberOfLines: numberOfLines,
      classNames: classNames,
      tagName: tagName
    }, children);
  }
  if (data) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: classNames,
      dangerouslySetInnerHTML: {
        __html: render(data)
      }
    });
  }
  return /*#__PURE__*/React__default.createElement(Element, _extends({
    className: classNames
  }, props), children);
};

var Breadcrumb = function Breadcrumb(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    href = _ref.href,
    modCurrent = _ref.modCurrent,
    linkComponent = _ref.linkComponent;
  var NextLink;
  try {
    NextLink = require('next/link')["default"];
  } catch (error) {
    NextLink = null;
  }
  var Link = linkComponent != null ? linkComponent : NextLink;
  if (modCurrent) {
    return /*#__PURE__*/React__default.createElement("span", {
      className: "breadcrumb",
      "aria-current": "page"
    }, icon && /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      size: 20,
      "aria-label": label,
      className: "breadcrumb__icon"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "breadcrumb__label"
    }, label));
  }
  if (parseInt(version) < 13 && !linkComponent) {
    return /*#__PURE__*/React__default.createElement(Link, {
      href: href
    }, /*#__PURE__*/React__default.createElement("a", {
      className: "breadcrumb"
    }, icon && /*#__PURE__*/React__default.createElement(Icon, {
      name: icon,
      size: 20,
      "aria-label": label,
      className: "breadcrumb__icon"
    }), /*#__PURE__*/React__default.createElement("span", {
      className: "breadcrumb__label"
    }, label)));
  }
  return /*#__PURE__*/React__default.createElement(Link, {
    href: href,
    className: "breadcrumb"
  }, icon && /*#__PURE__*/React__default.createElement(Icon, {
    name: icon,
    size: 20,
    "aria-label": label,
    className: "breadcrumb__icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "breadcrumb__label"
  }, label));
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var items = _ref.items,
    _ref$modStandalone = _ref.modStandalone,
    modStandalone = _ref$modStandalone === void 0 ? true : _ref$modStandalone,
    _ref$breadcrumbLabel = _ref.breadcrumbLabel,
    breadcrumbLabel = _ref$breadcrumbLabel === void 0 ? 'Breadcrumbs' : _ref$breadcrumbLabel,
    linkComponent = _ref.linkComponent;
  var prevPage = items[items.length > 1 ? items.length - 2 : 0];
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('breadcrumbs', modStandalone && 'breadcrumbs--standalone')
  }, /*#__PURE__*/React__default.createElement("ol", {
    className: "breadcrumbs__list",
    "aria-label": breadcrumbLabel
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "breadcrumb-" + index,
      className: cx('breadcrumbs__item', item === prevPage && 'breadcrumbs__item--mobile')
    }, item === prevPage && /*#__PURE__*/React__default.createElement(Icon, {
      name: "chevron-left",
      size: 16,
      className: "breadcrumbs__icon breadcrumbs__icon--mobile"
    }), /*#__PURE__*/React__default.createElement(Breadcrumb, _extends({
      modCurrent: index === items.length - 1,
      linkComponent: linkComponent
    }, item)), index !== items.length - 1 && /*#__PURE__*/React__default.createElement(Icon, {
      name: "chevron-right",
      size: 16,
      className: "breadcrumbs__icon"
    }));
  })));
};

var Card = function Card(_ref) {
  var title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    _ref$titleTagName = _ref.titleTagName,
    titleTagName = _ref$titleTagName === void 0 ? 'h4' : _ref$titleTagName,
    _ref$titleVariant = _ref.titleVariant,
    titleVariant = _ref$titleVariant === void 0 ? 'h5' : _ref$titleVariant,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
    modGhost = _ref.modGhost,
    modShowBlob = _ref.modShowBlob,
    modShadow = _ref.modShadow,
    modBorder = _ref.modBorder,
    header = _ref.header,
    footer = _ref.footer;
  var classNames = cx('card', "card--" + variant, "card--" + direction, modGhost && 'card--ghost', modShadow && 'card--shadow', modBorder && 'card--border', size && "card--" + size, className);
  var Component = tagName;
  return /*#__PURE__*/React__default.createElement(Component, {
    className: classNames
  }, header && /*#__PURE__*/React__default.createElement("div", {
    className: "card__header"
  }, header), /*#__PURE__*/React__default.createElement("div", {
    className: "card__inner"
  }, title && /*#__PURE__*/React__default.createElement(Heading, {
    variant: titleVariant,
    tagName: titleTagName,
    className: "card__heading"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "card__content"
  }, children)), footer && /*#__PURE__*/React__default.createElement("div", {
    className: "card__footer"
  }, footer), modShowBlob && /*#__PURE__*/React__default.createElement(Blob, {
    variant: 6,
    className: "card__blob"
  }));
};

var _excluded$b = ["src", "alt", "width", "height"];
var Image = function Image(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    width = _ref.width,
    height = _ref.height,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var NextImage;
  try {
    NextImage = require('next/image')["default"];
  } catch (error) {
    NextImage = null;
  }
  if (NextImage) {
    return /*#__PURE__*/React__default.createElement(NextImage, _extends({
      src: src,
      alt: alt,
      width: Number(width),
      height: Number(height)
    }, props));
  }
  return /*#__PURE__*/React__default.createElement("img", _extends({
    src: src,
    alt: alt,
    style: {
      width: width,
      height: height
    }
  }, props));
};

var PAGES = {
  Homepage: 'HomepageRecord',
  ProductsOverview: 'ProductsOverviewRecord',
  ProductDetail: 'ProductDetailRecord',
  CategoriesOverview: 'CategoriesOverviewRecord',
  CategoryDetail: 'CategoryDetailRecord',
  CategoryRecord: 'CategoryRecord',
  Page: 'PageRecord',
  Contact: 'ContactRecord'
};
function getHref(page) {
  if (!page) {
    return '/';
  }
  switch (page.__typename) {
    case PAGES.Homepage:
      {
        return '/';
      }
    case PAGES.Page:
      {
        if (!page.slug) {
          return '/';
        }
        if (page.slug === 'startpagina') {
          return '/';
        }
        return "/" + page.slug;
      }
    case PAGES.ProductsOverview:
      {
        return '/products';
      }
    case PAGES.ProductDetail:
      {
        if (!page.slug) {
          return '/';
        }
        return "/products/" + page.slug;
      }
    case PAGES.CategoriesOverview:
      {
        return '/products';
      }
    case PAGES.CategoryRecord:
    case PAGES.CategoryDetail:
      {
        if (!page.slug) {
          return '/';
        }
        return "/products/" + page.slug;
      }
  }
  console.warn(page);
  console.warn("No corresponding href formatter made for " + page.__typename);
  return '/';
}

var unifyLinkFormat = function unifyLinkFormat(data) {
  if (!(data !== null && data !== void 0 && data.__typename)) return null;
  if ((data === null || data === void 0 ? void 0 : data.__typename) === 'InternalLinkRecord') {
    var _unmaskedData = data;
    return {
      href: getHref(_unmaskedData.link),
      label: _unmaskedData.label,
      target: _unmaskedData.openInNewWindow ? '_blank' : '',
      iconAfter: _unmaskedData.openInNewWindow ? 'arrow-up-right' : undefined
    };
  }
  var unmaskedData = data;
  return {
    href: unmaskedData.url,
    label: unmaskedData.label,
    target: unmaskedData.openInNewWindow ? '_blank' : '',
    iconAfter: unmaskedData.openInNewWindow ? 'arrow-up-right' : undefined
  };
};

var FooterLegal = function FooterLegal(_ref) {
  var legal = _ref.legal,
    translations = _ref.translations,
    cmLogo = _ref.cmLogo,
    linkComponent = _ref.linkComponent;
  var year = new Date().getFullYear();
  if (!legal) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "footer__legal"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer__legal__inner"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "footer__legal__links"
  }, legal.links.map(function (link, i) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "legal-link-" + i
    }, /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(link), {
      variant: "white",
      size: "sm",
      linkComponent: linkComponent
    })));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "footer__copyright"
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "xsmall",
    className: "footer__copyright__text"
  }, /*#__PURE__*/React__default.createElement("strong", null, "\xA9 ", year, " Goed"), /*#__PURE__*/React__default.createElement("span", null, translations.togetherWith), ' ', /*#__PURE__*/React__default.createElement(Image, {
    src: cmLogo,
    width: 16,
    height: 16,
    alt: "CM"
  })), /*#__PURE__*/React__default.createElement(Text, {
    variant: "xsmall",
    className: "footer__copyright__text"
  }, /*#__PURE__*/React__default.createElement("strong", null, translations.vat, " ", legal.vat)))));
};

var FooterPaymentMethods = function FooterPaymentMethods(_ref) {
  var paymentMethods = _ref.paymentMethods;
  if (!paymentMethods) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "footer__payments"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "footer__payments__list"
  }, paymentMethods.map(function (paymentMethod, i) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: "payment-method-" + i
    }, paymentMethod.image && /*#__PURE__*/React__default.createElement(Image, {
      src: paymentMethod.image.url,
      width: 52,
      height: 52,
      alt: paymentMethod.title,
      className: "footer__payments__image"
    }));
  })));
};

var FooterPrimary = function FooterPrimary(_ref) {
  var _primary$left$callToA, _primary$right$title;
  var primary = _ref.primary,
    linkComponent = _ref.linkComponent;
  if (!primary) return /*#__PURE__*/React__default.createElement(Fragment$1, null);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "footer__primary"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer__primary__inner"
  }, primary.left && /*#__PURE__*/React__default.createElement("div", {
    className: "footer__col"
  }, /*#__PURE__*/React__default.createElement(Heading, {
    variant: "h5",
    tagName: "h3",
    className: "footer__primary__title"
  }, primary.left.title), /*#__PURE__*/React__default.createElement("ul", {
    className: "footer__links"
  }, primary.left.links.map(function (link) {
    return /*#__PURE__*/React__default.createElement(Fragment$1, {
      key: link.label
    }, link.label && /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(link), {
      linkComponent: linkComponent,
      variant: "white"
    }))));
  })), primary.left.callToAction && /*#__PURE__*/React__default.createElement(Card, {
    title: (_primary$left$callToA = primary.left.callToAction.title) != null ? _primary$left$callToA : '',
    titleVariant: "h6",
    direction: "horizontal",
    className: "footer__cta__card"
  }, /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(primary.left.callToAction.link), {
    variant: "white",
    iconAfter: "arrow-right",
    linkComponent: linkComponent
  })))), primary.middle && /*#__PURE__*/React__default.createElement("div", {
    className: "footer__col"
  }, /*#__PURE__*/React__default.createElement(Heading, {
    variant: "h5",
    tagName: "h3",
    className: "footer__primary__title"
  }, primary.middle.title), primary.middle.callToActions.map(function (cta, i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "footer__cta",
      key: "primary-middle-cta-" + i
    }, cta.description && /*#__PURE__*/React__default.createElement(Text, {
      variant: "default",
      data: cta.description,
      className: "footer__cta__content"
    }), cta.link && /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(cta.link), {
      variant: "white",
      iconAfter: "arrow-right",
      linkComponent: linkComponent
    })));
  })), primary.right && /*#__PURE__*/React__default.createElement("div", {
    className: "footer__col footer__col--socials"
  }, /*#__PURE__*/React__default.createElement(Card, {
    title: (_primary$right$title = primary.right.title) != null ? _primary$right$title : '',
    titleVariant: "h5",
    className: "footer__socials__card"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "footer__socials"
  }, primary.right.callToActions.map(function (cta, i) {
    var _cta$icon, _cta$icon2;
    return /*#__PURE__*/React__default.createElement("li", {
      key: "footer-social-" + i,
      className: "footer__socials__item"
    }, ((_cta$icon = cta.icon) === null || _cta$icon === void 0 ? void 0 : _cta$icon.icon) && /*#__PURE__*/React__default.createElement("span", {
      className: "footer__socials__icon"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: (_cta$icon2 = cta.icon) === null || _cta$icon2 === void 0 ? void 0 : _cta$icon2.icon,
      size: 16
    })), /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(cta.link), {
      variant: "white",
      linkComponent: linkComponent
    })));
  }))))));
};

var FooterSecondary = function FooterSecondary(_ref) {
  var secondary = _ref.secondary,
    linkComponent = _ref.linkComponent;
  if (!secondary) return /*#__PURE__*/React__default.createElement(Fragment$1, null);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "footer__secondary"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "footer__secondary__inner"
  }, secondary.items && secondary.items.map(function (item, i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "footer__col",
      key: "secondary-col-" + i
    }, /*#__PURE__*/React__default.createElement(Heading, {
      variant: "h5",
      tagName: "h3",
      className: "footer__secondary__title"
    }, item.title), /*#__PURE__*/React__default.createElement("ul", {
      className: "footer__links"
    }, item.links.map(function (link) {
      return /*#__PURE__*/React__default.createElement(Fragment$1, {
        key: link.label
      }, link.label && /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Link, _extends({}, unifyLinkFormat(link), {
        variant: "purple",
        linkComponent: linkComponent
      }))));
    })));
  })));
};

var Footer = function Footer(_ref) {
  var footer = _ref.footer,
    translations = _ref.translations,
    cmLogo = _ref.cmLogo,
    linkComponent = _ref.linkComponent;
  if (!footer) return /*#__PURE__*/React__default.createElement(Fragment, null);
  return /*#__PURE__*/React__default.createElement("footer", null, /*#__PURE__*/React__default.createElement(FooterPrimary, {
    primary: footer.primary,
    linkComponent: linkComponent
  }), footer.secondary && /*#__PURE__*/React__default.createElement(FooterSecondary, {
    secondary: footer.secondary,
    linkComponent: linkComponent
  }), footer.payments && /*#__PURE__*/React__default.createElement(FooterPaymentMethods, {
    paymentMethods: footer.payments
  }), footer.tertiary && /*#__PURE__*/React__default.createElement(FooterLegal, {
    translations: translations,
    cmLogo: cmLogo,
    legal: footer.tertiary,
    linkComponent: linkComponent
  }));
};

export { Blob, Breadcrumbs, Button, Card, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogInner, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, Footer, FooterLegal, FooterPaymentMethods, FooterPrimary, FooterSecondary, Heading, Icon, IconButton, Link, Loader, Logo$1 as Logo, Text };
//# sourceMappingURL=index.modern.js.map
